import { configureStore } from '@reduxjs/toolkit'

import { socketMiddleware } from './middleware/socketMiddleware'
import { bulkActionsReducer } from './modules/filters/bulkActionsSlice'
import { filterMetadataReducer } from './modules/filters/filterMetaSlice'
import { savedFiltersReducer } from './modules/filters/savedFiltersSlice'
import { socketsReducer } from './modules/sockets/slice'
import { accountReducer } from '@modules/accountData/slice'
import { challengesReducer } from '@modules/challenges/slice'
import { sessionReducer } from '@modules/session/slice'
import { usersReducer } from '@modules/users/slice'

export const store = configureStore({
  reducer: {
    session: sessionReducer,
    challenges: challengesReducer,
    accounts: accountReducer,
    users: usersReducer,
    filterMeta: filterMetadataReducer,
    savedFilters: savedFiltersReducer,
    bulkActions: bulkActionsReducer,
    sockets: socketsReducer,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(socketMiddleware),
})

// RootStore type
// export type AppStore = typeof store
// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>
// Inferred type: {  posts: PostsState, comments: CommentsState, users: UsersState  };
export type AppDispatch = typeof store.dispatch
